import { useEffect, useState } from 'react'
import { ListboxOption, ListboxOptions } from '@headlessui/react'
import { Check } from '../at-icon'
import { DropdownOption } from './index'
import { useRouter } from 'next/compat/router'

export const DropdownListbox = ({
  options,
  className = '',
  anchorTo = 'bottom',
  hasBuildings = false,
}: {
  options: DropdownOption[]
  className?: string
  anchorTo?: 'bottom' | 'bottom start' | 'bottom end'
  hasBuildings?: boolean
}) => {
  const router = useRouter()
  const [preselectedBuilding, setPreselectedBuilding] = useState<boolean>(false)

  const handleChange = () => {
    setPreselectedBuilding(false)
  }

  useEffect(() => {
    setPreselectedBuilding(true)
  }, [])

  return (
    <ListboxOptions
      transition={true}
      anchor={{
        to: anchorTo,
      }}
      className={`${className} z-50 !max-h-80 overflow-y-auto shadow-level-4 border-1 border-neutrals-300 rounded-8 outline-none bg-neutrals-white`}
    >
      {options?.map((option, index) => (
        <ListboxOption key={option.id ?? option.value ?? index} value={option} onClick={handleChange}>
          {({ selected, focus }) => {
            hasBuildings && preselectedBuilding && (selected = router?.query.building === option.id)
            return (
              <div
                className={`h-14 p-4 cursor-pointer leading-1.5 flex justify-between items-center gap-2 border-b-1 border-neutrals-300 text-neutrals-800 ${
                  selected
                    ? 'bg-neutrals-300 text-neutrals-900 font-bold'
                    : focus
                    ? 'bg-neutrals-300 text-neutrals-900'
                    : ''
                }`}
              >
                <span className="flex items-center gap-2 min-w-0 flex-1">
                  {option.iconLeft != null && (
                    <span className="shrink-0 text-neutrals-900 [&_svg]:w-4 [&_svg]:h-5">{option.iconLeft}</span>
                  )}
                  {option.label}
                </span>
                {selected && <Check className="text-primary-500 shrink-0" />}
              </div>
            )
          }}
        </ListboxOption>
      ))}
    </ListboxOptions>
  )
}
